import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, InputNumber } from 'antd';
import * as actionTypes from '../../redux/actions/agent/actionTypes';
import { updateShareDetail } from '../../redux/actions/agent/updateAgent';


class UpdateShareDetailModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onUpdate({
            id:this.props.agent?.id,
            shareDetailId:this.props.agent?.shareDetail?.id,
            sharePercentage:values.sharePercentage,
            threeDSharePercentage:values.threeDSharePercentage,
            // fourDSharePercentage:values.fourDSharePercentage,
        });
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Update Share Detail"
                key={this.props.agent?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-sd-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                    layout="vertical"
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-sd-form"
                    name="basic"
                    initialValues={{
                        sharePercentage:this.props.agent?.shareDetail?.sharePercentage,
                        threeDSharePercentage:this.props.agent?.shareDetail?.threeDSharePercentage,
                        // fourDSharePercentage:this.props.agent?.shareDetail?.fourDSharePercentage
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="sharePercentage"
                        label="Share Percentage"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                    <Form.Item
                        name="threeDSharePercentage"
                        label="Three D Share Percentage"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                    {/* <Form.Item
                        name="fourDSharePercentage"
                        label="Four D Share Percentage"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item> */}
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.agent.updateShareDetailVisible,
    loading: state.agent.loading,
    error: state.agent.error,
    message: state.agent.message,
    agent:state.agent.one
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (info) => dispatch(updateShareDetail(info)),
    onClose: () => dispatch({
        type:actionTypes.TOGGLE_SHARE_DETAIL_UPDATE
    }),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateShareDetailModal);